function GlobalPageLoader() {
  return (
    <div className="global-page-loader" role="status" aria-live="polite" aria-label="Cargando contenido">
      <div className="global-loader-panel">
        <img src="/images/VPA.png" alt="Vintage Pro Audio" className="global-loader-logo" />

        <h2 className="global-loader-title">Vintage Pro Audio</h2>
        <p className="global-loader-subtitle">Preparando tu experiencia de compra</p>

        <div className="global-loader-bars" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}

export default GlobalPageLoader;
